
































































































































































































































import { Vue, Component, Prop } from "vue-property-decorator";
import { RichiestaTirFormativi } from "../../_models/richiestaTirFormativi";

@Component
export default class DetailsRichiestaTirFormativo extends Vue {
  @Prop() info!: RichiestaTirFormativi;
}
